var React = require('react');

function AnimatedCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"2864-__checkmark__check","fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}));
}

AnimatedCheck.displayName = "AnimatedCheck";

AnimatedCheck.defaultProps = {"viewBox":"0 0 52 52"};

module.exports = AnimatedCheck;

AnimatedCheck.default = AnimatedCheck;
